import { render, staticRenderFns } from "./WorkorderInfoTopNew.vue?vue&type=template&id=2ecdc9a2&scoped=true"
import script from "./WorkorderInfoTopNew.vue?vue&type=script&lang=js"
export * from "./WorkorderInfoTopNew.vue?vue&type=script&lang=js"
import style0 from "./WorkorderInfoTopNew.vue?vue&type=style&index=0&id=2ecdc9a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecdc9a2",
  null
  
)

export default component.exports